module.exports = __webpack_public_path__ + "static/media/balls.a5f37500.png";